import React, { PureComponent } from 'react';
import { Spin, Modal, notification } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import { connect } from 'dva';
@connect(({ login }) => ({
  loaderStatus: login.awsMarketPlaceResponse,
}))
class AWSMarketPlace extends PureComponent {
  componentDidMount() {
    const { dispatch } = this.props;

    notification.open({
      message: this.props.loaderStatus,
      description: '',
      onClick: () => {},
    });
    // }
  }
  render() {
    const { status } = this.props;

    return <div />;
  }
}

export default AWSMarketPlace;
